import type { ComponentType } from 'react';
import type { DashboardVariant } from '../data/domains/config';
import { MenuFlowItemCard, type MenuFlowItemCardProps } from './components/MenuFlowItemCard';
import { MenuFlowHeader, type MenuFlowHeaderProps } from './components/MenuFlowHeader';
import { MenuFlowBottomMacroBar, getMenuListBottomContentPadding } from './components/MenuFlowBottomMacroBar';
import { MenuFlowItemCardSet2 } from './variants/set2/MenuFlowItemCardSet2';
import { MenuFlowHeaderSet2 } from './variants/set2/MenuFlowHeaderSet2';
import { MenuFlowBottomMacroBarSet2, getSet2MenuListBottomContentPadding } from './variants/set2/MenuFlowBottomMacroBarSet2';

export function resolveMenuFlowItemCard(variant: DashboardVariant): ComponentType<MenuFlowItemCardProps> {
  if (variant === 'set2') {
    return MenuFlowItemCardSet2;
  }
  // set1 + set3 → studio chrome (v3 implementation; set1 v1 card split TBD)
  return MenuFlowItemCard;
}

export function resolveMenuFlowHeader(variant: DashboardVariant): ComponentType<MenuFlowHeaderProps> {
  if (variant === 'set2') {
    return MenuFlowHeaderSet2;
  }
  return MenuFlowHeader;
}

export function resolveMenuFlowBottomMacroBar(variant: DashboardVariant): typeof MenuFlowBottomMacroBar {
  if (variant === 'set2') {
    return MenuFlowBottomMacroBarSet2 as typeof MenuFlowBottomMacroBar;
  }
  return MenuFlowBottomMacroBar;
}

export function resolveMenuListBottomContentPadding(variant: DashboardVariant): (safe_area_bottom: number) => number {
  if (variant === 'set2') {
    return getSet2MenuListBottomContentPadding;
  }
  return getMenuListBottomContentPadding;
}
